import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/**
 * The old password-based admin login has been retired — that password was
 * a hardcoded literal in the public JS bundle, so it was never real
 * security. Admin access already works correctly through the normal
 * magic-code sign-in: AdminProtectedRoute/AdminAuthContext grant admin
 * status automatically once a signed-in user's own email matches the
 * admin allowlist. So this route just forwards to the real sign-in page,
 * preserving where the visitor was headed.
 */
const AdminLogin: React.FC = () => {
  const location = useLocation()
  return <Navigate to="/login" state={location.state} replace />
}

export default AdminLogin
